module.exports = __webpack_public_path__ + "static/media/identityConfirmed-ph.83db1ed2.svg";